/* eslint-disable */
import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';

import { getMyProfile } from './user';
import {check as anyUserLoggedIn, setAuthorizationToken} from '../utils/tokenUtils';
import {
  GET_MY_STORES_LIST_REP_FULFILLED,
  GET_MY_STORES_LIST_REP_PENDING,
  GET_MY_STORES_LIST_REP_REJECTED,
  GET_SCANNING_DISABLED_OUTLETS_PENDING,
  GET_SCANNING_DISABLED_OUTLETS_FULFILLED,
  GET_SCANNING_DISABLED_OUTLETS_REJECTED,
  REENABLE_SCANNING_PENDING,
  REENABLE_SCANNING_FULFILLED,
  REENABLE_SCANNING_REJECTED
} from '../reducers/storeReducer';
import { GET_TEAM_OUTLET_PENDING, GET_TEAM_OUTLET_FULFILLED, GET_TEAM_OUTLET_REJECTED } from '../reducers/teamStoreDetailReducer';

export const validateRegistrationOutlet = (payload, registration, fromRegistrationPage = false) =>
  irelandApi.post('/api/users/outlet_validation', {outlet: payload})
  .then((response) => {
    store.dispatch({
      type: 'OUTLET_VALIDATION_FULFILLED',
      payLoad: {
        customer_number: response.data.outlet.customer_number,
        eircode: response.data.outlet.eircode,
        passcode: response.data.outlet.passcode,
        reward_store: response.data.outlet.reward_store,
      }
    });
    store.dispatch({
      type: 'SET_REGISTRATION_TOKEN',
      payLoad: {registration_token: response.data.registration_token}
    });
    store.dispatch(actions.change('deep.yourStore', {
      customer_number: response.data.outlet.customer_number,
      updated_eircode: response.data.outlet.eircode,
      updated_name: response.data.outlet.name,
      updated_address_1: response.data.outlet.address_1,
      updated_address_2: response.data.outlet.address_2,
      updated_address_3: response.data.outlet.address_3,
      updated_town: response.data.outlet.town,
      updated_county: response.data.outlet.county,
    }));

    if (!anyUserLoggedIn()) {
      return history.push('/registration/about-you');
    }

    if (fromRegistrationPage) {
      history.push('/registration/your-store');
    } else {
      history.push('/your-store');
    }
  })
  .catch(error => {
    const data = {
        ...error.response.data.errors
    };
    return Promise.reject(data)
  });

const useRegistrationPage = (registration) => !!registration.fromRegistrationPage;

export const updateOutlet = (payload, addMore, registration, pending_user_id) => (
  irelandApi.post(`/api/${registration.fromRegistrationPage ? 'users' : 'outlets'}/your_store`, {
    outlet: payload,
    registration_token: registration.registration_token,
    pending_user_id: pending_user_id
  })
    .then((response) => {
      if (response.headers.authorization) {
        const token = response.headers.authorization.split(' ')[1];
        setAuthorizationToken(token);
      }
      store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {registration_token: response.data.registration_token}
      });
      if (addMore) {
        store.dispatch({
          type: 'ADD_MORE_REGISTRATION',
          payLoad: { pending_user_id: response.data.pending_user_id }
        });
        store.dispatch(actions.reset('deep.registration.outlet_validation'));
        store.dispatch(actions.reset('deep.yourStore'));

        return history.push(
          useRegistrationPage(registration) ? '/registration/outlet' : '/outlet'
        );
      }
      if (useRegistrationPage(registration)) {
        history.push('/registration/store-summary');
      } else {
        store.dispatch({ type: 'FINISH_REGISTRATION' });
        history.push('/store-summary');
      }
    })
    .catch((error) => {
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {registration_token: error.response.data.registration_token}
      });
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    })
);

// TODO: simplify with promise middleware like this
// export const getOutlets = () => (dispatch) => dispatch({type: "GET_OUTLETS", payload: irelandApi.get('/api/outlets')});

export const getOutlets = registration => (dispatch) => {
  dispatch({
    type: 'GET_OUTLETS_PENDING',
    payload: []
  });
  return irelandApi.get('/api/outlets', {params: {param: registration ? 'registration' : ''}})
    .then((response) => {
      if (registration) {
        const outlets = response.data.data.map((store) => {
          return {
            customer_number: store.attributes['customer-number']
          };
        });
        dispatch(actions.load('deep.store_summary', outlets));
      }
      dispatch({
        type: 'GET_OUTLETS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_OUTLETS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getAdminOutlets = (filter = '', page = '') => (dispatch) => {
  dispatch({
    type: 'GET_OUTLETS_PENDING',
    payload: []
  });
  return irelandApi.get('/api/admin/outlets', {
    params: {
      q: filter,
      page
    }
  })
    .then((response) => {
      dispatch({
        type: 'GET_ADMIN_OUTLETS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_OUTLETS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getCustomerNumbers = (filter = '', page = '', pay_for_performance = false, limit = false) => (dispatch) => {
  filter = `?q=${filter}&page=${page}`;
  if (pay_for_performance) {
    filter = `${filter}&pay_for_performance=Y`;
  }
  if (limit) {
    filter = `${filter}&limit=true`;
  }
  dispatch({
    type: 'GET_OUTLETS_CN_PENDING',
    payload: []
  });
  return irelandApi.get(`/api/admin/outlets/customer_numbers${filter}`)
    .then((response) => {
      dispatch({
        type: 'GET_OUTLETS_CN_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_OUTLETS_CN_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getCustomerNumbersForPendingOutlet = filter => dispatch => {
  dispatch({ type: 'GET_PENDING_OUTLETS_CN_PENDING' });

  return irelandApi
    .get(`/api/admin/pending_outlets/customer_numbers`, { params: { q: filter } })
    .then(({ data }) => dispatch({ type: 'GET_PENDING_OUTLETS_CN_FULFILLED', payLoad: data }))
    .catch(({ response: { data } }) => {
      dispatch({ type: 'GET_PENDING_OUTLETS_CN_REJECTED', payLoad: data });
      return Promise.reject(data);
    });
}

export const getOutlet = id => (dispatch) => {
  dispatch({
    type: 'GET_OUTLET_PENDING',
    payload: []
  });
  return irelandApi
    .get(`/api/outlets/${id}`)
    .then((response) => {
      dispatch({
        type: 'GET_OUTLET_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_OUTLET_REJECTED',
        payLoad: error.response
      });
    });
};

export const getAdminOutlet = id => (dispatch) => {
  dispatch({
    type: 'GET_OUTLET_PENDING',
    payload: []
  });
  return irelandApi
    .get(`/api/admin/outlets/${id}`)
    .then((response) => {
      dispatch({
        type: 'GET_OUTLET_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error =>
      // dispatch({type: 'GET_OUTLET_REJECTED', payLoad: error});

      Promise.reject(error));
};

export const getTeamOutlet = id => (dispatch) => {
  dispatch({
    type: GET_TEAM_OUTLET_PENDING,
    payload: []
  });
  return irelandApi
    .get(`/api/team/outlets/${id}`)
    .then((response) => {
      dispatch({
        type: GET_TEAM_OUTLET_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_TEAM_OUTLET_REJECTED,
        payLoad: error.response
      });
    });
};

export const delinkOutlet = payLoad => (dispatch) => {
  dispatch({
    type: 'GET_OUTLETDELINK_PENDING',
    payload: []
  });
  const payLoadRequest = {
    delink_date: payLoad.delink_date,
    delink_reason: payLoad.delink_reason,
    supress_notification: payLoad.supress_notification,
  };
  return irelandApi
    .patch(`/api/admin/outlets/${payLoad.outlet}/delink`, {delink: payLoadRequest})
    .then((response) => {
      dispatch({type: 'GET_OUTLETDELINK_FULFILLED'});
      dispatch(actions.reset('deep.admin_delink'));
      history.push('/admin/outlets/delink');
      toast.success(<ToastMessage iconStyle="success" message="Outlet has been successfully delinked"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delink"/>);
      dispatch({
        type: 'GET_OUTLETDELINK_REJECTED',
        payLoad: error.response.data.errors
      });
      return Promise.reject(error.response.data.errors);
    });
};

export const delinkUserOutlet = storeId => (dispatch) => {
  dispatch({
    type: 'GET_USEROUTLETDELINK_PENDING',
    payload: []
  });
  return irelandApi
    .get(`/api/outlets/${storeId}/outlet_removal`)
    .then((response) => {
      dispatch({type: 'GET_USEROUTLETDELINK_FULFILLED'});
      toast.success(<ToastMessage iconStyle="success" message="Outlet delink request has been successfully sent"/>);
    })
    .catch((error) => {
      dispatch({
        type: 'GET_USEROUTLETDELINK_REJECTED',
        payLoad: error.data
      });
    });
};

export const updateOutletReward = payload => irelandApi.patch('/api/users/staff_rewards', {outlets: payload})
  .then((response) => {
    store.dispatch({type: 'FINISH_REGISTRATION'});
    return history.push('/');
  })
  .catch(({ response }) => {
    if (response.status === 401) return history.push('/');

    toast.error(<ToastMessage iconStyle="error" message="An error occured during update"/>);
    return Promise.reject(response.data);
  });

export const updateOutletRest = (id, payload, dispatch) => {
  const data = { ...payload };
  dispatch(actions.resetValidity('deep.admin_outlet_view'));
  dispatch({type: 'GET_OUTLET_UPDATE_PENDING'});

  return irelandApi.patch(`/api/admin/outlets/${id}`, {outlet: data})
    .then((response) => {
      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Outlet has been successfully saved"/>);
      history.push('/admin/outlets');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during save outlet"/>);
      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: error.response.data
      });

      if (error.response.data.hasOwnProperty('errors')) {
        return Promise.reject(error.response.data.errors);
      }

      return Promise.reject(error.response.data);
    });
};

export const updateOutletGroups = (id, payload, dispatch) => dispatch => {
  dispatch(actions.reset('deep.admin_outlet_view.groups'));
  dispatch({type: 'GET_OUTLET_UPDATE_PENDING'});

  return irelandApi.patch(`/api/admin/outlets/${id}`, payload)
    .then((response) => {

      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: response.data
      });

      toast.success(<ToastMessage iconStyle="success" message="Outlet has been successfully saved"/>);
      dispatch(getAdminOutlet(id));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during save outlet"/>);
      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: error.response.data
      });

      if (error.response.data.hasOwnProperty('errors')) {
        return Promise.reject(error.response.data.errors);
      }

      return Promise.reject(error.response.data);
    });
};

export const getOutletMapFeatureCollection = (rbm = '') => dispatch => {
  dispatch({type: 'GET_OUTLET_MAP_PENDING'});
  return irelandApi.get(`/api/outlets/map_view`, {params: {rbm_code: rbm}})
    .then((response) => {
      dispatch({
        type: 'GET_OUTLET_MAP_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Cannot load outlets for map view."/>);
      dispatch({
        type: 'GET_OUTLET_MAP_REJECTED',
      });


      return Promise.reject(error);
    });
};

export const getOutletRBMCodes = () => dispatch => {
  dispatch({type: 'GET_OUTLET_RBMS_PENDING'});
  return irelandApi.get(`/api/outlets/rbm_codes`)
    .then((response) => {
      dispatch({
        type: 'GET_OUTLET_RBMS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Cannot fetch RBM codes."/>);
      dispatch({
        type: 'GET_OUTLET_RBMS_REJECTED',
      });


      return Promise.reject(error);
    });
};

export const getMyStoresListRep = (filter = '', page = '') => (dispatch) => {
    dispatch({
      type: GET_MY_STORES_LIST_REP_PENDING,
    });
    return irelandApi.get('/api/team/outlets', {
      params: {
        q: filter,
        page
      }
    })
      .then((response) => {
        dispatch({
          type: GET_MY_STORES_LIST_REP_FULFILLED,
          payLoad: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MY_STORES_LIST_REP_REJECTED,
          payLoad: error.data
        });
        return Promise.reject(error.response.data);
      });
  };

export const invalidateScans = (outlet, payLoad, dispatch) => {
  return irelandApi.patch(`/api/admin/outlets/${outlet}/invalidate_scans`, { outlet: payLoad })
    .then((response) => {
      dispatch({
        type: 'INVALIDATE_SCANS_FULFILLED',
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Scans invalidated successfully"/>);
      history.push('/admin/outlets');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during invalidating scans"/>);
      dispatch({
        type: 'INVALIDATE_SCANS_FULFILLED',
        payload: error.response.data
      });

      if (error.response.data.hasOwnProperty('errors')) {
        return Promise.reject(error.response.data.errors);
      }

      return Promise.reject(error.response.data);
    });
};

export const getScanningDisabledOutlets = (path) => (dispatch) => {
  dispatch({ type: GET_SCANNING_DISABLED_OUTLETS_PENDING });

  return irelandApi.get(`/api/${path}/outlets/scanning_disabled`)
    .then((response) => {
      dispatch({
        type: GET_SCANNING_DISABLED_OUTLETS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SCANNING_DISABLED_OUTLETS_REJECTED,
        payLoad: error.response
      });
    });
};

export const reenableScanning = (id, path) => (dispatch) => {
  dispatch({ type: REENABLE_SCANNING_PENDING });

  return irelandApi.patch(`/api/${path}/outlets/${id}/reenable_scanning`)
    .then((response) => {
      dispatch({
        type: REENABLE_SCANNING_FULFILLED,
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Outlet has been successfully updated" />);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during update" />);
      dispatch({
        type: REENABLE_SCANNING_REJECTED,
        payLoad: error.response.data
      });
    });
};
